export default "__VITE_ASSET__Cs5f51yW__"